<template>
  <router-view/>
</template>

<script>
import store from '@/store'
import { getAuthToken, removeAuthData } from '@/libs/auth-helper'
import { STORAGE_KEY, storageManager } from '@/libs/storage-manager'

export default {
  name: 'TheMember',
  methods: {
  },
  beforeRouteEnter (to, from, next) {
    const authToken = getAuthToken()

    const goSignIn = () => {
      removeAuthData()
      return next({ name: 'sign-in' })
    }

    if (!authToken) {
      return goSignIn()
    }

    store.dispatch('storeUserData').then(userData => {
      if (!userData) {
        return goSignIn()
      } else {
        storageManager.initUser(userData.userNum)
        const stickyDataId = storageManager.getItem(STORAGE_KEY.stickyDataId)
        let showStickyData = storageManager.getItem(STORAGE_KEY.showStickyData)
        let showNoPvDialog = storageManager.getItem(STORAGE_KEY.showNoPvDialog)

        if (showStickyData === null) {
          showStickyData = true
          storageManager.setItem(STORAGE_KEY.showStickyData, showStickyData)
        }

        if (showNoPvDialog === null) {
          showNoPvDialog = true
          storageManager.setItem(STORAGE_KEY.showNoPvDialog, showNoPvDialog)
        }
        store.commit('setStickyDataId', stickyDataId)
        store.commit('setShowStickyData', showStickyData)
        store.commit('setShowNoPvDialog', showNoPvDialog)
        return store.dispatch('storePlanData')
      }
    }).then(() => {
      next()
    }).catch(err => {
      console.error(err)
      return goSignIn()
    })
  }
}
</script>

<style>

</style>
